export function extractFileNameFromContentDisposition(
  contentDisposition: string,
): string | null {
  if (!contentDisposition) return null;

  const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
  if (fileNameMatch && fileNameMatch[1]) {
    return fileNameMatch[1];
  }

  const encodedFileNameMatch = contentDisposition.match(
    /filename\*=UTF-8''(.+)/,
  );
  if (encodedFileNameMatch && encodedFileNameMatch[1]) {
    try {
      return decodeURIComponent(encodedFileNameMatch[1]);
    } catch {
      return encodedFileNameMatch[1];
    }
  }

  return null;
}

export function generateFallbackFileName(reportId: string): string {
  return `report-${reportId}.pdf`;
}
